import React from 'react';
import { BedIcon, CalendarRangeIcon, CompassIcon, ClipboardListIcon, MoonIcon, RefreshCwIcon, ShieldCheckIcon, TimerIcon, MoonStarIcon } from 'lucide-react';
import { CtaBlock, CtaButton } from '../components/CtaButton';
import { FaqItem } from '../components/FaqItem';
import { InsidePages } from '../components/InsidePages';
import { StickyCta } from '../components/StickyCta';
import { GUARANTEE_TEXT, GUARANTEE_TITLE, faqs, guides, heroBenefits, offerIncludes, painPoints, testimonials } from '../data/content';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/3mwrhkUoCDtynSAjfGyryU/mockup2.png';
const LIFESTYLE_URL = 'https://cdn.magicpatterns.com/patterns/generated-images/e6a6c5cf-96a0-4b94-b2be-7cd50b5302df.jpg';
const benefitIcons = [CompassIcon, ClipboardListIcon, CalendarRangeIcon];
const painIcons = [TimerIcon, MoonIcon, BedIcon, RefreshCwIcon];
const OFFER_META = 'Instant Digital Access • 6 Digital Guides • One-Time Payment';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-40" data-mp="3aki4a0ey7yw1">
      {/* Header */}
      <header className="border-b border-brand-charcoal/10 bg-brand-ivory" data-id="element-41" data-mp="35qx5451mcyv9">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-2.5 lg:px-8" data-id="element-42" data-mp="30ugen46y68f0">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-43" data-mp="2vwex4np66h5n">
            Prof.Kyra
          </p>
          <div className="flex items-center gap-4" data-id="element-44" data-mp="3ojr8e1pvr2jn">
            <p className="font-body text-[11px] uppercase tracking-[0.14em] text-brand-charcoal/55" data-id="element-45" data-mp="3ok0ydpaxd9pc">
              6 Guides · <span className="font-semibold text-brand-charcoal" data-id="element-46" data-mp="3jilh88bvbnc8">23 USD</span>
            </p>
            <CtaButton label="Get Access" size="md" className="hidden px-4 py-2 text-[11px] md:inline-flex" data-id="element-47" data-mp="3fijnclcdjy7i" />
          </div>
        </div>
      </header>

      <main data-id="element-48" data-mp="245qybiayxnv5">
        {/* 01 — HERO */}
        <section className="bg-brand-ivory px-5 pb-14 pt-10 lg:px-8 lg:pb-20 lg:pt-14" data-id="element-49" data-mp="25ka5ewjx72v2">
          <div className="mx-auto max-w-3xl text-center" data-id="element-50" data-mp="2ajmr3dz223w2">
            <p className="flex items-center justify-center gap-2 font-body text-[11px] font-medium uppercase tracking-[0.2em] text-brand-charcoal/55" data-id="element-51" data-mp="2aj4wsmvydzqs">
              <MoonStarIcon className="h-3.5 w-3.5 text-brand-charcoal/40" strokeWidth={1.25} aria-hidden="true" data-id="element-52" data-mp="20l78jze3g2y6" />
              Real Solutions for Tired Parents
            </p>
            <h1 className="mt-5 font-display text-[2.3rem] font-bold leading-[1.06] tracking-[-0.01em] text-brand-charcoal sm:text-[3rem] lg:text-[3.5rem]" data-id="element-53" data-mp="1rmlhffuk3fls">
              Tired of 20-Minute Naps, Bedtime Battles &amp; Constant Night Wakings?
            </h1>
            <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-base" data-id="element-54" data-mp="13uy11rux7mxr">
              Stop guessing when your baby should sleep. Get age-by-age wake windows, nap times and
              simple routines to build calmer, more predictable sleep from birth to 24 months.
            </p>
          </div>

          {/* Product — warm halo so the mockup sits in the page, not on top of it */}
          <div className="relative mx-auto mt-10 w-full max-w-[600px] lg:mt-12" data-id="element-55" data-mp="ya8ikiboodub">
            <div aria-hidden="true" className="absolute left-1/2 top-[54%] h-[64%] w-[86%] -translate-x-1/2 -translate-y-1/2 rounded-[50%] bg-brand-oatmeal opacity-70 blur-2xl" data-id="element-56" data-mp="ta2wris3hlk5" />
            <img src={MOCKUP_URL} alt="The Baby Sleep Bible by Prof. Kyra — the complete set of six digital sleep guides" className="relative mx-auto block w-full max-w-[360px] object-contain lg:max-w-[560px]" style={{
            filter: 'drop-shadow(0 26px 30px rgba(120, 84, 64, 0.16))'
          }} data-id="element-57" data-mp="137qsaaxiyx3d" />
          </div>

          <div className="mx-auto mt-10 max-w-4xl" data-id="element-58" data-mp="1lzjmg8obyoco">
            <ul className="grid gap-6 border-y border-brand-charcoal/10 py-7 sm:grid-cols-3" role="list" data-id="element-59" data-mp="1lwx5jifjuwhs">
              {heroBenefits.map((benefit, index) => {
              const Icon = benefitIcons[index];
              return <li key={benefit.label} className="text-center" data-id="element-60" data-mp="2etzonh69n6g7" data-mpi={index}>
                    <Icon className="mx-auto h-5 w-5 text-brand-charcoal/70" strokeWidth={1.25} aria-hidden="true" data-id="element-61" data-mp="2jssqudg3rb12" />
                    <p className="mt-2.5 font-body text-[14px] font-semibold text-brand-charcoal" data-id="element-62" data-mp="1r33pu03e7azg">
                      {benefit.label}
                    </p>
                    <p className="mx-auto mt-1 max-w-[16rem] text-[13px] leading-relaxed text-brand-charcoal/60" data-id="element-63" data-mp="1w5b631v99d7l">
                      {benefit.description}
                    </p>
                  </li>;
            })}
            </ul>

            <div id="hero-cta" data-id="element-64" data-mp="3cfx0ivq54dj6">
              <CtaBlock label="Get the Baby Sleep Bible" meta={OFFER_META} className="mt-9" data-id="element-65" data-mp="3cjb2i2uw6kq3" />
            </div>
          </div>
        </section>

        {/* 02 — PROBLEM */}
        <section aria-labelledby="problem-heading" className="bg-brand-blush px-5 py-14 lg:px-8 lg:py-20" data-id="element-66" data-mp="vw3638swp9br">
          <div className="mx-auto max-w-2xl text-center" data-id="element-67" data-mp="r1p42njqo3y4">
            <h2 id="problem-heading" className="font-display text-[2rem] font-bold leading-[1.12] text-brand-charcoal sm:text-4xl" data-id="element-68" data-mp="m474vovix33b">
              When Sleep Changes, Everything Changes.
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-69" data-mp="857f2dw9yi5k">
              Your baby&apos;s sleep can be unpredictable. You shouldn&apos;t have to start your
              research from zero every time something shifts.
            </p>
          </div>

          <div className="mx-auto mt-10 grid max-w-5xl items-center gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-14" data-id="element-70" data-mp="22ifd0efjr9vf">
            <img src={LIFESTYLE_URL} alt="A baby sleeping calmly in a quiet, neutral nursery" loading="lazy" decoding="async" className="aspect-[4/5] w-full rounded-[16px] object-cover" data-id="element-71" data-mp="1xiaxorqdkl6s" />
            <ul className="border-t border-brand-charcoal/15" role="list" data-id="element-72" data-mp="3i3r5jygl7b3o">
              {painPoints.map((pain, index) => {
              const Icon = painIcons[index];
              return <li key={pain} className="flex items-center gap-3.5 border-b border-brand-charcoal/15 py-4" data-id="element-73" data-mp="elz5rxw7lmux" data-mpi={index}>
                    <Icon className="h-[18px] w-[18px] flex-none text-brand-charcoal/55" strokeWidth={1.25} aria-hidden="true" data-id="element-74" data-mp="5lj7r3y8j7xg" />
                    <span className="text-[15px] leading-snug text-brand-charcoal" data-id="element-75" data-mp="2qa7812iprp3o">{pain}</span>
                  </li>;
            })}
            </ul>
          </div>

          <CtaBlock label="Get Instant Access" className="mx-auto mt-12 max-w-md" data-id="element-76" data-mp="2ms9n3bhci5l8" />
        </section>

        {/* 03 — THE SYSTEM */}
        <section aria-labelledby="system-heading" className="bg-brand-ivory px-5 py-14 lg:px-8 lg:py-20" data-id="element-77" data-mp="2htq33gmbb3vi">
          <div className="mx-auto max-w-6xl" data-id="element-78" data-mp="2rsfa2eco73wz">
            <div className="mx-auto max-w-2xl text-center" data-id="element-79" data-mp="2rtgv9bneh6sf">
              <p className="font-body text-[11px] font-medium uppercase tracking-[0.2em] text-brand-charcoal/55" data-id="element-80" data-mp="2421rrfjw0jfl">
                The System
              </p>
              <h2 id="system-heading" className="mt-4 font-display text-[2rem] font-bold leading-[1.12] text-brand-charcoal sm:text-4xl" data-id="element-81" data-mp="1z1dq7zy18k74">
                One Sleep System. Six Essential Guides.
              </h2>
              <p className="mt-4 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-82" data-mp="1lb1w5vhw0bdc">
                Each guide covers a different challenge and stage, so the system stays with you as
                your baby grows and sleep keeps shifting.
              </p>
            </div>

            <ol className="mt-10 grid gap-x-14 border-t border-brand-charcoal/12 sm:grid-cols-2" data-id="element-83" data-mp="zs8s84uacih2">
              {guides.map(guide => <li key={guide.number} className="flex items-start gap-4 border-b border-brand-charcoal/12 py-6" data-id="element-84" data-mp="14qaawonsufs0">
                  <span className="mt-0.5 flex h-9 w-9 flex-none items-center justify-center rounded-full font-body text-[12px] font-semibold text-brand-charcoal" style={{
                backgroundColor: guide.accent
              }} aria-hidden="true" data-id="element-85" data-mp="1dt1n4qoi1fkp">
                    {guide.number}
                  </span>
                  <span data-id="element-86" data-mp="1sj8x0i0fxq9s">
                    <span className="block font-display text-[1.35rem] font-bold leading-snug text-brand-charcoal" data-id="element-87" data-mp="1wjjg8wd8ud6l">
                      {guide.title}
                    </span>
                    <span className="mt-1.5 block text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-88" data-mp="3m057ov9dy5oe">
                      {guide.description}
                    </span>
                  </span>
                </li>)}
            </ol>
          </div>
        </section>

        {/* 04 — A LOOK INSIDE */}
        <section aria-labelledby="inside-heading" className="bg-brand-paper px-5 py-14 lg:px-8 lg:py-20" data-id="element-89" data-mp="380nhcbgfykcx">
          <div className="mx-auto max-w-6xl" data-id="element-90" data-mp="8jyx0wa78q4v">
            <div className="mx-auto max-w-2xl text-center" data-id="element-91" data-mp="4jnbzidxcnsv">
              <p className="font-body text-[11px] font-medium uppercase tracking-[0.2em] text-brand-charcoal/55" data-id="element-92" data-mp="4k6ub07hle7f">
                A Look Inside
              </p>
              <h2 id="inside-heading" className="mt-4 font-display text-[2rem] font-bold leading-[1.12] text-brand-charcoal sm:text-4xl" data-id="element-93" data-mp="3qzri6wxtx7ti">
                Practical Guidance for Real Life.
              </h2>
              <p className="mt-4 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-94" data-mp="ngg59en3don7">
                Clear schedules, practical guidance and easy-reference tools designed for tired
                parents.
              </p>
            </div>

            <div className="mt-10" data-id="element-95" data-mp="3affycywbt6ya">
              <InsidePages data-id="element-96" data-mp="3aghirtz8f5so" />
            </div>

            <CtaBlock label="Get All 6 Guides" meta="6 Digital Guides • Instant Access • One-Time Payment" className="mx-auto mt-12 max-w-md border-t border-brand-charcoal/12 pt-10" data-id="element-97" data-mp="36dkx1ueeatki" />
          </div>
        </section>

        {/* 05 — TESTIMONIALS */}
        <section aria-labelledby="testimonials-heading" className="bg-brand-blush px-5 py-14 lg:px-8 lg:py-20" data-id="element-98" data-mp="3u2nlbl3jbknz">
          <div className="mx-auto max-w-6xl" data-id="element-99" data-mp="3p4cezkcg7sai">
            <h2 id="testimonials-heading" className="text-center font-display text-[2rem] font-bold leading-[1.12] text-brand-charcoal sm:text-4xl" data-id="element-100" data-mp="6xy1tnm07md6">
              What Parents Say.
            </h2>
            <div className="mt-10 grid gap-10 sm:grid-cols-3 sm:gap-8" data-id="element-101" data-mp="lm7ubamx9afb">
              {testimonials.map(testimonial => <blockquote key={testimonial.name} className="border-t border-brand-charcoal/20 pt-6" data-id="element-102" data-mp="qj7zljby695d">
                  <p className="font-display text-[1.3rem] font-normal italic leading-[1.45] text-brand-charcoal" data-id="element-103" data-mp="gl217bpcnl59">
                    “{testimonial.quote}”
                  </p>
                  <footer className="mt-5" data-id="element-104" data-mp="7kvf51fl5cuh">
                    <p className="font-body text-[13px] font-semibold text-brand-charcoal" data-id="element-105" data-mp="7lwzjwihrbov">
                      {testimonial.name}
                    </p>
                    <p className="mt-0.5 font-body text-[12px] uppercase tracking-[0.14em] text-brand-charcoal/50" data-id="element-106" data-mp="3u0gebubdosvv">
                      {testimonial.country}
                    </p>
                  </footer>
                </blockquote>)}
            </div>
          </div>
        </section>

        {/* 06 — FINAL OFFER */}
        <section id="offer" aria-labelledby="offer-heading" className="bg-brand-oatmeal px-5 py-14 lg:px-8 lg:py-20" data-id="element-107" data-mp="1qkl6ovr166a3">
          <div className="mx-auto max-w-3xl text-center" data-id="element-108" data-mp="1gtqj9o21t0n2">
            <p className="font-body text-[11px] font-medium uppercase tracking-[0.2em] text-brand-charcoal/55" data-id="element-109" data-mp="1gu9pw8m902ls">
              The Complete Bundle
            </p>
            <h2 id="offer-heading" className="mt-4 font-display text-[2.2rem] font-bold leading-[1.08] text-brand-charcoal sm:text-[2.6rem]" data-id="element-110" data-mp="29ixjcrh5hyaf">
              The Baby Sleep Bible
            </h2>

            <div className="relative mx-auto mt-8 w-full max-w-[460px]" data-id="element-111" data-mp="20g64siszamek">
              <div aria-hidden="true" className="absolute left-1/2 top-[56%] h-[60%] w-[84%] -translate-x-1/2 -translate-y-1/2 rounded-[50%] bg-[#E3D3BF] opacity-70 blur-2xl" data-id="element-112" data-mp="1vhuwwdm8ulyz" />
              <img src={MOCKUP_URL} alt="The Baby Sleep Bible — six digital guides included in the bundle" loading="lazy" decoding="async" className="relative mx-auto block w-full max-w-[320px] object-contain lg:max-w-[420px]" style={{
              filter: 'drop-shadow(0 22px 26px rgba(120, 84, 64, 0.18))'
            }} data-id="element-113" data-mp="k2fwezuttbz4" />
            </div>

            <ul className="mx-auto mt-8 inline-flex flex-col gap-2.5 text-left" role="list" data-id="element-114" data-mp="3ehko26ts1de2">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal/75" data-id="element-115" data-mp="3jfm6cpjdp8oh">
                  <span aria-hidden="true" className="mt-2 h-1 w-1 flex-none rounded-full bg-brand-charcoal/40" data-id="element-116" data-mp="3sh3jbz1hou8y" />
                  {item}
                </li>)}
            </ul>

            <CtaBlock label="Get the Baby Sleep Bible" meta="One-Time Payment • Instant Digital Access" className="mx-auto mt-9 max-w-md border-t border-brand-charcoal/15 pt-8" data-id="element-117" data-mp="1y3uggq3g86zo" />
          </div>
        </section>

        {/* 07 — FAQ */}
        <section aria-labelledby="faq-heading" className="bg-brand-ivory px-5 py-14 lg:px-8 lg:py-20" data-id="element-118" data-mp="1cq0qvfljgiqf">
          <div className="mx-auto max-w-3xl" data-id="element-119" data-mp="17q61jghew17h">
            <h2 id="faq-heading" className="text-center font-display text-[2rem] font-bold leading-[1.12] text-brand-charcoal sm:text-4xl" data-id="element-120" data-mp="k1wk0qr8dzm5">
              Questions, Answered.
            </h2>
            <div className="mt-8 border-t border-brand-charcoal/12" data-id="element-121" data-mp="ttsgjxdo5ho9">
              {faqs.map(faq => <FaqItem key={faq.question} {...faq} data-id="element-122" data-mp="p0g56oy037dg" />)}
            </div>
          </div>
        </section>

        {/* Guarantee */}
        <section aria-labelledby="guarantee-heading" className="border-y border-brand-charcoal/10 bg-brand-paper px-5 py-12 lg:px-8" data-id="element-123" data-mp="3sizpn5aft8xp">
          <div className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-124" data-mp="27ym55wica3bz">
            <ShieldCheckIcon className="h-6 w-6 text-brand-charcoal/60" strokeWidth={1.25} aria-hidden="true" data-id="element-125" data-mp="2csgmwuedw88f" />
            <h2 id="guarantee-heading" className="mt-4 font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-126" data-mp="232dtwu79iua3">
              {GUARANTEE_TITLE}
            </h2>
            <p className="mt-3 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-127" data-mp="2vp8avh4vfbit">
              {GUARANTEE_TEXT}
            </p>
          </div>
        </section>
      </main>

      {/* 08 — FOOTER */}
      <footer className="bg-brand-charcoal px-5 pb-36 pt-12 text-brand-ivory/70 md:pb-12 lg:px-8" data-id="element-128" data-mp="2mrfxwjmmgfyl">
        <div className="mx-auto flex max-w-6xl flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-129" data-mp="16d67zl2qej5n">
          <p className="font-body text-[13px] font-semibold uppercase tracking-[0.22em] text-brand-ivory" data-id="element-130" data-mp="1b7tpgzzbidaq">
            Prof.Kyra
          </p>
          <nav aria-label="Footer" className="flex flex-wrap gap-x-7 gap-y-2 font-body text-[13px]" data-id="element-131" data-mp="381afn7myh67a">
            <a href="#terms" className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-132" data-mp="338hbakvefzvq">
              Terms
            </a>
            <a href="#privacy" className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-133" data-mp="2p9hws61lp1da">
              Privacy Policy
            </a>
            <a href="#refund" className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-134" data-mp="ijl4rd9azbna">
              Refund Policy
            </a>
            <a href="mailto:profkyra@gmail.com" className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-135" data-mp="21dmroo3memtz">
              Contact
            </a>
          </nav>
        </div>
        <p className="mx-auto mt-8 max-w-6xl font-body text-[12px] leading-relaxed text-brand-ivory/45" data-id="element-136" data-mp="1dijyy51p3z88">
          © 2026 Prof.Kyra. The Baby Sleep Bible is an educational resource and does not constitute
          medical advice. 7-day money-back guarantee. Payments are processed in your local currency.
        </p>
      </footer>

      <StickyCta data-id="element-137" data-mp="2xwkkbkm250c1" />
    </div>;
}